export default {
    primary: {
        bg: 'primary_2',
        color: 'neutral_0',
        px: '20px',
        py: '10px',
    },
    secondary: {
        bg: 'neutral_3',
        color: 'neutral_8',
        px: '20px',
        py: '10px',
    },
    flagged: {
        bg: 'secondary_2',
        color: 'neutral_0',
        px: '20px',
        py: '10px',
    },
    neutral: {
        bg: 'neutral_0',
        color: 'neutral_8',
        px: '20px',
        py: '10px',
    },
    custom: {
        bg: 'neutral_3',
        color: 'neutral_8',
        padding: 0,
    },
};
